import { render, staticRenderFns } from "./CustomReportPage2.vue?vue&type=template&id=ce7d5562&scoped=true&"
import script from "./CustomReportPage2.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage2.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportPage2.vue?vue&type=style&index=0&id=ce7d5562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7d5562",
  null
  
)

export default component.exports